export const PIPE_STOCK_REPORT_REQUEST = 'PIPE_STOCK_REPORT_REQUEST';
export const PIPE_STOCK_REPORT_SUCCESS = 'PIPE_STOCK_REPORT_SUCCESS';
export const PIPE_STOCK_REPORT_FAILURE = 'PIPE_STOCK_REPORT_FAILURE';
export const PIPE_STOCK_FILTER_REPORT_REQUEST = 'PIPE_STOCK_FILTER_REPORT_REQUEST';
export const PIPE_STOCK_FILTER_REPORT_SUCCESS = 'PIPE_STOCK_FILTER_REPORT_SUCCESS';
export const PIPE_STOCK_FILTER_REPORT_FAILURE = 'PIPE_STOCK_FILTER_REPORT_FAILURE';